module.exports = __webpack_public_path__ + "static/media/social-detail.f9ed030f.jpg";